// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"404":"2d54fdb9","766":"16708ad7","823":"8e8cef88","845":"c86c2b0d","858":"14abab77"}[chunkId] + ".css";
};